import MessageApi from '../../../../api/inbox/message';

export default {
  async sendMessageToBpo(_, { conversationId, messageId }) {
    try {
      await MessageApi.sendToBpo(conversationId, messageId);
    } catch (error) {
      // ignore error
    }
  },

  async sendSelectedMessagesToBpo({ rootState, dispatch }, { conversationId }) {
    const selection = rootState.conversations.conversationFilters?.bpoSelection;
    const ids = selection?.selected || [];
    if (!ids.length) {
      throw new Error('No messages selected');
    }
    await MessageApi.sendToBpoBulk(conversationId, ids);
    await dispatch('clearBpoSelection');
  },
};


